import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacy from "../pages/Privacy";
import Kvkk from "../pages/Kvkk";
import Cookies from "../pages/Cookies";
import Hakkimizda from "../pages/hakkimizda/page";
import Hizmetler from "../pages/hizmetler/page";
import PerformansPazarlama from "../pages/hizmetler/performans-pazarlama/page";
import SeoPage from "../pages/hizmetler/seo/page";
import MarkaStratejisi from "../pages/hizmetler/marka-stratejisi/page";
import WebGelistirme from "../pages/hizmetler/web-gelistirme/page";
import Noropazarlama from "../pages/hizmetler/noropazarlama/page";
import KampanyaYonetimi from "../pages/hizmetler/kampanya-yonetimi/page";
import ETicaret from "../pages/sektorler/e-ticaret-dijital-pazarlama/page";
import EndustriyelB2B from "../pages/sektorler/endustriyel-b2b-pazarlama/page";
import Ihracat from "../pages/sektorler/ihracat/page";
import SiyasiKampanya from "../pages/sektorler/siyasi-kampanya/page";
import Iletisim from "../pages/iletisim/page";
import Vakalar from "../pages/vakalar/page";
import VakaDetay from "../pages/vakalar/components/VakaDetay";
import Icgoruler from "../pages/icgoruler/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ankara-dijital-pazarlama-ajansi",
    element: <Hakkimizda />,
  },
  {
    path: "/hizmetler",
    element: <Hizmetler />,
  },
  {
    path: "/hizmetler/performans-pazarlama",
    element: <PerformansPazarlama />,
  },
  {
    path: "/hizmetler/seo",
    element: <SeoPage />,
  },
  {
    path: "/hizmetler/marka-stratejisi",
    element: <MarkaStratejisi />,
  },
  {
    path: "/hizmetler/web-gelistirme",
    element: <WebGelistirme />,
  },
  {
    path: "/hizmetler/noropazarlama",
    element: <Noropazarlama />,
  },
  {
    path: "/hizmetler/kampanya-yonetimi",
    element: <KampanyaYonetimi />,
  },
  {
    path: "/sektorler/e-ticaret-dijital-pazarlama",
    element: <ETicaret />,
  },
  {
    path: "/sektorler/endustriyel-b2b-pazarlama",
    element: <EndustriyelB2B />,
  },
  {
    path: "/sektorler/ihracat",
    element: <Ihracat />,
  },
  {
    path: "/sektorler/siyasi-kampanya",
    element: <SiyasiKampanya />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "/basarili-dijital-projeler",
    element: <Vakalar />,
  },
  {
    path: "/basarili-dijital-projeler/:slug",
    element: <VakaDetay />,
  },
  {
    path: "/dijital-pazarlama-blog",
    element: <Icgoruler />,
  },
  {
    path: "/gizlilik-politikasi",
    element: <Privacy />,
  },
  {
    path: "/kvkk",
    element: <Kvkk />,
  },
  {
    path: "/cerez-politikasi",
    element: <Cookies />,
  },
  // 301 redirects: eski URL'ler → yeni SEO URL'leri
  {
    path: "/kullanim-sartlari",
    element: <Navigate to="/kvkk" replace />,
  },
  {
    path: "/hakkimizda",
    element: <Navigate to="/ankara-dijital-pazarlama-ajansi" replace />,
  },
  {
    path: "/vakalar",
    element: <Navigate to="/basarili-dijital-projeler" replace />,
  },
  {
    path: "/icgoruler",
    element: <Navigate to="/dijital-pazarlama-blog" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;